import aos from 'aos';
import 'aos/dist/aos.css';

aos.init({
  disable: 'mobile',
});
